import { RootState } from 'editor/src/store/index';

const getDpiLevelsSettings = (state: RootState) => state.hostSettings.dpiLevels;

export default getDpiLevelsSettings;
